import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIEffect } from './onboarding-info.effects';
import { STORE_TYPE } from './onboarding-info.model';
import { uiReducer } from './onboarding-info.reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(STORE_TYPE, uiReducer), EffectsModule.forFeature([UIEffect])],
  exports: [],
})
export class UIOnboardingInfoStoreModule {}